import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const defaultNS = 'translation';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    defaultNS,
    fallbackLng: {
      'nl': ['nl-NL', 'en'],
      'nl-NL': ['en'],
      'da-DK': ['da', 'en'],
      'de': ['de-DE', 'en-GB', 'en'],
      'de-DE': ['en-GB', 'en'],
      'en-AU': ['en-GB', 'en'],
      'en-UK': ['en-GB', 'en'],
      'en-GB': ['en'],
      'en-US': ['en-GB', 'en'],
      'en-IE': ['en-GB', 'en'],
      'es-ES': ['es', 'en'],
      'fr': ['fr-FR', 'en'],
      'fr-FR': ['en'],
      'fr-BE': ['fr-FR', 'en'],
      'nl-BE': ['nl-NL', 'en'],
      'no-NO': ['en-GB', 'en'],
      'sv': ['sv-SE', 'en'],
      'sv-SE': ['sv', 'en'],
      'default': ['en'],
    },
    detection: {
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator'],
      // An unregistered visitor's manual language choice is client-only: cache it
      // in localStorage (a local variable, not the account) so it survives a
      // reload and wins over the browser preference on the next visit.
      caches: ['localStorage'],
    },
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: process.env.REACT_APP_MYTOVER_API + '/lang/{{lng}}/{{ns}}.json?v=' + Date.now(),
      addPath: process.env.REACT_APP_MYTOVER_API + '/translation/add/{{lng}}/{{ns}}',
      allowMultiLoading: false,
    },
    saveMissing: true,
    appendNamespaceToMissingKey: true,
  });

// Keep the document's <html lang> in sync with the active language. i18next does
// not touch it, so index.html's static lang="en" would otherwise never change —
// wrong for screen readers and the browser's translate prompt (note translate="no"),
// and it lets tests read the active language from a single stable place. Fires on
// the initial resolve and on every changeLanguage (browser detection, the header
// language menu, account settings, and the account-language applied on sign-in).
const syncDocumentLanguage = () => {
  // resolvedLanguage is the language actually used to render (a supported tag,
  // after fallback) — e.g. an unsupported browser preference resolves to the
  // fallback. That is what <html lang> should advertise, not the raw request.
  const lng = i18n.resolvedLanguage || i18n.language;
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng;
  }
};
i18n.on('languageChanged', syncDocumentLanguage);
syncDocumentLanguage();

export default i18n;
